import http from '../../../plugins/axios';

export default {

    getUserTags(data) {
        return http.get({
            url : '/admin/user/tag/get',
            data
        })
    },

    insertUserTags(data) {
        return http.post({
            url : '/admin/user/tag/insert',
            data,
            dataType: 'form'
        })
    },

    getMachineType() {
        return http.get({
            url : '/admin/user/tag/machineType'
        })
    },

    alterUserTagStatus(data){
        return http.post({
            url : '/admin/user/tag/alterStatus',
            data,
            dataType: 'form'
        })
    },

    excelUserTag() {
        return http.post({
            url: '/admin/user/tag/export',
            responseType: 'blob'
        })
    }

}
